(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3-collapsible-tabs"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.collapsible-columns');
  const collapsibles = document.querySelectorAll('.collapsible-btn');

  // Handle Tab Clicks
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      const tabNumber = this.getAttribute('data-tab');

      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove('active'));

      // Add active class to the clicked tab
      this.classList.add('active');

      // Hide all tab contents
      tabContents.forEach(content => content.style.display = 'none');

      // Show the selected tab content
      document.getElementById(`tab-content-${tabNumber}`).style.display = 'block';
    });
  });

  // Handle Collapsible Clicks
  collapsibles.forEach(btn => {
    btn.addEventListener('click', function () {
      const collapsible = this.closest('.collapsible'); // Get the closest parent collapsible div
      const content = collapsible.querySelector('.content'); // Get the content div within the collapsible

      // Toggle the content display
      if (content.style.display === 'block') {
        content.style.display = 'none';
        collapsible.classList.remove('activated-class-accordian'); // Remove class when collapsing
      } else {
        content.style.display = 'block';
        collapsible.classList.add('activated-class-accordian'); // Add class when expanding
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["button-pop-up"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
    // Function to open a popup
    const openPopup = (popupId) => {
        document.getElementById(popupId).style.display = 'flex';
    };

    // Function to close a popup
    const closePopup = () => {
        document.querySelectorAll('.popup').forEach(popup => {
            popup.style.display = 'none';
        });
    };

    // Attach click event to all buttons with class 'open-popup'
    document.querySelectorAll('.open-popup').forEach(button => {
        button.addEventListener('click', () => {
            const popupId = button.getAttribute('data-popup');
            openPopup(popupId);
        });
    });

    // Attach click event to all close buttons inside popups
    document.querySelectorAll('.close-popup').forEach(button => {
        button.addEventListener('click', closePopup);
    });

    // Close popup when clicking outside of the content area
    document.querySelectorAll('.popup').forEach(popup => {
        popup.addEventListener('click', (event) => {
            if (event.target === popup) {
                closePopup();
            }
        });
    });
});


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cozy-tabs-banner"] && !Shopify.designMode) return;
  try {
    

  document.querySelectorAll('.custom-tab-button').forEach(button => {
    button.addEventListener('click', () => {
        const tabID = button.getAttribute('data-custom-tab');

        // Remove 'is-active' class from all buttons and add to the clicked one
        document.querySelectorAll('.custom-tab-button').forEach(btn => btn.classList.remove('is-active'));
        button.classList.add('is-active');

        // Remove 'is-active' class from all tables and add to the selected one
        document.querySelectorAll('.custom-table').forEach(tab => tab.classList.remove('is-active'));
        const activeTab = document.getElementById('custom-tab-' + tabID);
        activeTab.classList.add('is-active');

        // Update the background image of 'cozy-tabs-banner' based on the active tab's data-id
        const imageUrl = activeTab.getAttribute('data-id');
        document.querySelector('.cozy-tabs-banner').style.backgroundImage = `url('${imageUrl}')`;
    });
});



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sproduct-slider"] && !Shopify.designMode) return;
  try {
    

  const slider = document.querySelector('.video-slider');
const prevBtn = document.querySelector('.prev-slide');
const nextBtn = document.querySelector('.next-slide');

let currentSlide = 0;

prevBtn.addEventListener('click', () => {
    if (currentSlide > 0) {
        currentSlide--;
        updateSlider();
    }
});

nextBtn.addEventListener('click', () => {
    if (currentSlide < slider.children.length - 3) { // Show only up to the last half-visible slide
        currentSlide++;
        updateSlider();
    }
});

function updateSlider() {
    slider.style.transform = `translateX(-${currentSlide * (100 / 3.5)}%)`;
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-tab-link-btn').forEach(button => {
      button.addEventListener('click', () => {
          const tabID = button.getAttribute('data-tab');

          // Remove 'active' class from all buttons
          document.querySelectorAll('.product-tab-link-btn').forEach(btn => btn.classList.remove('active'));

          // Add 'active' class to the clicked button
          button.classList.add('active');

          // Remove 'active' class from all tab content
          document.querySelectorAll('.product-tab-main').forEach(tab => tab.classList.remove('active'));

          // Add 'active' class to the corresponding tab content
          document.getElementById('product-tab-' + tabID).classList.add('active');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-designed"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-tab-link-btn').forEach(button => {
      button.addEventListener('click', () => {
          const tabID = button.getAttribute('data-tab');

          // Remove 'active' class from all buttons
          document.querySelectorAll('.product-tab-link-btn').forEach(btn => btn.classList.remove('active'));

          // Add 'active' class to the clicked button
          button.classList.add('active');

          // Remove 'active' class from all tab content
          document.querySelectorAll('.product-tab-main').forEach(tab => tab.classList.remove('active'));

          // Add 'active' class to the corresponding tab content
          document.getElementById('product-tab-' + tabID).classList.add('active');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["troubleshooting-tabs-video"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', () => {
    // Get the hash from the URL (e.g., #product-tab-btn2)
    const hash = window.location.hash;

    // Check if there is a hash and if it matches one of the tab buttons
    if (hash) {
        const button = document.querySelector(hash);
        if (button) {
            const tabID = button.getAttribute('data-tab');

            // Remove 'active' class from all buttons and tab contents
            document.querySelectorAll('.product-tab-link-btn').forEach(btn => btn.classList.remove('active'));
            document.querySelectorAll('.product-tab-main').forEach(tab => tab.classList.remove('active'));

            // Add 'active' class to the corresponding button and tab content
            button.classList.add('active');
            document.getElementById('product-tab-' + tabID).classList.add('active');
        }
    }

    // Add event listeners to buttons for manual clicking
    document.querySelectorAll('.product-tab-link-btn').forEach(button => {
        button.addEventListener('click', () => {
            const tabID = button.getAttribute('data-tab');

            // Update the URL hash without reloading the page
            window.location.hash = button.id;

            // Remove 'active' class from all buttons and tab contents
            document.querySelectorAll('.product-tab-link-btn').forEach(btn => btn.classList.remove('active'));
            document.querySelectorAll('.product-tab-main').forEach(tab => tab.classList.remove('active'));

            // Add 'active' class to the clicked button and corresponding tab content
            button.classList.add('active');
            document.getElementById('product-tab-' + tabID).classList.add('active');
        });
    });
});


  } catch(e) { console.error(e); }
})();
})();
